import { Injectable } from '@angular/core';
import { MenuEntry } from '@services/menu/entry.schema';
import { SideMenuService } from '@services/menu/side-menu.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { CallcardListMenuEntry } from '../../../schema/menu/callcard-list-menu-entry';

@AddinExecute({
  name: 'Callcard list menu',
  description: "Provide some menu items to open CallCard's view"
})
@Injectable()
export class CallcardListMenuService extends Execute {
  private callcardListMenu: MenuEntry;

  constructor(private sideMenuService: SideMenuService) {
    super();
  }

  init(): void {}

  execute(): void {
    this.callcardListMenu = new CallcardListMenuEntry();
    this.sideMenuService.addMenuEntry(this.callcardListMenu);
  }

  destroy(): void {
    this.sideMenuService.removeMenuEntry(this.callcardListMenu);
  }
}
